import { render, staticRenderFns } from "./CustomMetadataSelector.vue?vue&type=template&id=92d98974&lang=pug"
import script from "./CustomMetadataSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMetadataSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports